module.exports = __webpack_public_path__ + "static/media/trade.cb39cf9f.png";